"use strict";function e(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(exports,"__esModule",{value:!0});const t=e(require("styled-components")).default.div.withConfig({displayName:"ModalContainer",componentId:"VDS__sc-19nh2hf-0"})`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: ${({zIndex:e})=>e};
`;exports.default=t;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/modals/cjs/components/ModalContainer.js
// module id = 1043
// module chunks = 0